import * as Yup from 'yup';

export default Yup.object({
  password: Yup.string()
    .min(8, 'Must be at least 8 characters')
    .matches(/\d/, 'Must contain a number')
    .matches(/[a-z]/g, 'Must contain a lowercase letter')
    .matches(/[A-Z]/g, 'Must contain an uppercase letter')
    .required('Required')
});
